import { render, staticRenderFns } from "./access-control-sale-overview.vue?vue&type=template&id=5a32efaf&scoped=true&"
import script from "./access-control-sale-overview.vue?vue&type=script&lang=ts&"
export * from "./access-control-sale-overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32efaf",
  null
  
)

export default component.exports